import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { Button } from '@blueprintjs/core';
import styled from '@emotion/styled';

const CenterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

interface EditCellProps extends ICellRendererParams {
  onEditButtonClick: (params: any) => void;
}

class EditCell extends React.Component<EditCellProps> {
  render() {
    const { onEditButtonClick } = this.props;

    return (
      <CenterContainer>
        <Button onClick={onEditButtonClick} icon={'edit'} small={true} />
      </CenterContainer>
    );
  }
}

export default EditCell;
